// Must match enum defined in
// https://dropbox.sourcegraphcloud.com/github.com/dropbox-internal/server/-/blob/metaserver/lib/dash/gating/dash_gating_types.py?L44:7-44:26
export enum RedirectVariant {
  CountryBlock = "country_block",
  GenericBlock = "generic_block",
  PendingInviteBlock = "pending_invite_block",
  DfbOnboarding = "dfb_onboarding",
  UnverifiedEmail = "unverified_email",
  NoLicenseBlock = "no_license_block",
  BridgeOnboarding = "bridge_onboarding",
  SuspendedPaidSubscription = "suspended_paid_subscription",
  SuspendedTrialSubscription = "suspended_trial_subscription",
}
